// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"577bf144","705":"577bf144"}[chunkId] + ".chunk.css";
};